import { render, staticRenderFns } from "./p2.vue?vue&type=template&id=e7673df4&"
import script from "./p2.vue?vue&type=script&lang=js&"
export * from "./p2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports